import NudosConfirmActionModal from '../../../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import { updateOrganizationConfigActiveStatus } from '../../../../../../services/product-configuration.service';
import { displaySuccessNotification } from '../../../../../../utils/displayNudosStandardNotifications';
import useConfigurationGlobalState from '../configurationGlobalState';
import useSWRMutation from 'swr/mutation';
import { SWR_KEYS } from '../../../../../../constants/constants';
import { IOrganizationConfig } from '../../../../../../types/product.configuration.types';
import './InactiveConfigModal.scss';

const InactiveConfigModal = ({
  closeModalCallback,
  mutateGetOrganizationConfigByOrganizationId
}: {
  closeModalCallback: () => void;
  mutateGetOrganizationConfigByOrganizationId: () => Promise<IOrganizationConfig[] | undefined>;
}) => {
  const { trigger: updateConfigurationStatusTrigger, isMutating: isLoadingUpdateConfigurationStatus } = useSWRMutation(
    SWR_KEYS.updateConfigurationStatus,
    async (
      __,
      {
        arg
      }: {
        arg: {
          isActivate: boolean;
          uuid: string;
        };
      }
    ) => {
      return await updateOrganizationConfigActiveStatus(arg.isActivate, arg.uuid);
    },
    {
      onSuccess: () => {
        closeModalCallback();
        displaySuccessNotification({
          customJSXMessage: <>Configuración se inactivó correctamente </>
        });
        mutateGetOrganizationConfigByOrganizationId();
      }
    }
  );

  const { configUnit } = useConfigurationGlobalState();

  return (
    <NudosConfirmActionModal
      modalText={
        <div className="inactiveConfigModalText">
          Estás por inactivar la configuración <strong>{configUnit?.name}</strong>. No se eliminará la configuración a
          las herramientas aplicadas, pero no podrás utilizarlo nuevamente, ¿deseas continuar?
        </div>
      }
      firstButtonText="No, cancelar"
      secondButtonText="Sí, inactivar"
      firstButtonAction={closeModalCallback}
      secondButtonAction={() => {
        updateConfigurationStatusTrigger({
          isActivate: false,
          uuid: configUnit?.uuid ?? ''
        });
      }}
      customHeight="270px"
      isLoading={isLoadingUpdateConfigurationStatus}
    />
  );
};

export default InactiveConfigModal;
